import { AuxiliumComponent } from "../auxilium-component";

export class Label extends AuxiliumComponent {
	constructor() {
		super();

		this.type = this.getAttribute("type") ?? "";
		this.for = this.getAttribute("for") ?? "";

		if (this.type === "secondary") {
			this.classList.add("input-field__helper-text");
		} else {
			this.classList.add("input-field__label");
		}
	}

	parsedCallback() {
		const element = document.createElementWithContents(this.for ? "label" : "span", this.childNodes);

		if (this.for) {
			const forTarget = document.getElementById(this.for);

			if (forTarget?.matches("chip-input, chip-checkbox, chip-textarea, chip-radio, chip-colourpicker, chip-button")) {
				element.htmlFor = forTarget.identifier;
			} else {
				element.htmlFor = this.for;
			}
		}

		this.appendChild(element);
	}
}